import { useEffect } from 'react';
import type { UIComponent } from '~/services/layout';
import logger from '~/services/logger';

export const useSubscribeToActionRefreshComponent = ({
  clientFeedApiEndpoint,
  fetcherData,
  fetchData,
  uiComponent,
}: {
  clientFeedApiEndpoint: string | null;
  fetcherData: any;
  fetchData: (forceFresh: boolean) => void;
  uiComponent: UIComponent;
}) => {
  const hasFetcherData = Boolean(fetcherData);
  const hasEntryRefreshAction = fetcherData?.entry?.find((action: any) =>
    action?.extensions?.tap_actions?.actions?.find(
      (a: any) => a.type === 'refreshComponent'
    )
  );

  useEffect(() => {
    if (hasFetcherData && hasEntryRefreshAction) {
      // Warn if load_feed_from_client is not enabled
      if (!uiComponent?.rules?.load_feed_from_client) {
        logger.info(
          `action:refreshComponent would not work – UI Component -> Rules -> load_feed_from_client is set to false; see uiComponent ID: ${uiComponent?.id}`
        );
      } else {
        logger.info(
          `Subscribed to "action:refreshComponent" for datasource: ${clientFeedApiEndpoint}; see uiComponent ID: ${uiComponent?.id}`
        );

        const listener = (e: Event) => {
          const detail = (e as CustomEvent).detail;
          const url = new URL(detail.feedPath);

          const urlMatches = (url1: URL, clientFeedApiEndpoint: string) => {
            try {
              const url2Obj = new URL(
                clientFeedApiEndpoint,
                window.location.origin
              );
              return (
                url1.origin + url1.pathname ===
                url2Obj.searchParams.get('feed-url')
              );
            } catch {
              return false;
            }
          };

          if (urlMatches(url, clientFeedApiEndpoint || '')) {
            fetchData(true);
          }
        };

        window.addEventListener('action:refreshComponent', listener);
        return () => {
          window.removeEventListener('action:refreshComponent', listener);
        };
      }
    }
  }, [
    clientFeedApiEndpoint,
    fetchData,
    uiComponent,
    hasFetcherData,
    hasEntryRefreshAction,
    fetcherData,
  ]);
};
